import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { Configuration } from '@common/models';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Devuelve todas las configuraciones
   * @returns {Observable<Configuration[]>} Devuelve un observable de tipo array de configuraciones
   */
  getAll(): Observable<Configuration[]> {
    return this._http.get<Configuration[]>(`${environment.commonApiUrl}/api/configurations`);
  }

  /**
   * Devuelve todas las configuraciones según el tipo
   * @param {string} type Indica el tipo de configuración
   * @returns {Observable<Configuration[]>} Devuelve un observable de tipo array de configuraciones
   */
  getByType(type: string): Observable<Configuration[]> {
    return this._http.get<Configuration[]>(`${environment.commonApiUrl}/api/configurations/type/${type}`);
  }

  /**
   * Devuelve una configuración por su nombre
   * @param {string} name Indica el nombre de la configuración
   * @returns {Observable<Configuration>} Devuelve un observable de tipo Configuración
   */
  getByName(name: string): Observable<Configuration> {
    return this._http.get<Configuration>(`${environment.commonApiUrl}/api/configurations/${name}`);
  }

  /**
   * Función para crear una nueva configuración
   * @param {Configuration} configuration Objeto de tipo Configuración
   * @returns {Observable<Configuration>} Devuelve un observable de tipo Configuración
   */
  addConfiguration(configuration: Configuration): Observable<Configuration>{
    return this._http.post<Configuration>(`${environment.commonApiUrl}/api/configurations`, configuration).pipe(
      map((response: any) => response.configuration as Configuration),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función para editar una configuración ya existente
   * @param {Configuration} configuration Objeto de tipo Configuración
   * @returns {Observable<Configuration>} Devuelve un observable de tipo Configuración
   */
  editConfiguration(configuration: Configuration): Observable<Configuration>{
    return this._http.put<Configuration>(`${environment.commonApiUrl}/api/configurations/${configuration.id}`, configuration).pipe(
      map((response: any) => response.configuration as Configuration),
      catchError(e => {
        return throwError(e);
      })
    );
  }
  
}
